import cx from 'clsx';
import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { Tooltip } from 'react-tooltip';

import { ReactComponent as DoubleArrowIcon } from '@assets/svg/double-arrow.svg';
import { ReactComponent as AngleDowntimeIcon } from '@assets/svg/sensors-temperature/angle_downtime.svg';
import { ReactComponent as AngelEndIcon } from '@assets/svg/sensors-temperature/angle_end.svg';
import { ReactComponent as EquipmentIcon } from '@assets/svg/sensors-temperature/equipment_D111.svg';
import { ReactComponent as D134EquipmentIcon } from '@assets/svg/sensors-temperature/equipment_D134.svg';
import { ReactComponent as IndicatorIcon } from '@assets/svg/sensors-temperature/indicator.svg';
import { ReactComponent as StraightConnectorIcon } from '@assets/svg/sensors-temperature/straight_connector.svg';
import { ReactComponent as UnitIcon } from '@assets/svg/sensors-temperature/unit.svg';

import useTranslation from '@hooks/useTranslation';

import style from './style.module.scss';

interface IProps {
  installationPoints: Map<string, any>; //TODO:remove any
  userMetric: string;
}

const ThirdRow: React.FC<IProps> = ({ installationPoints, userMetric }) => {
  const { t } = useTranslation();

  const { customerId } = useParams();

  const SENSORS_TEMPERATURE_TOOLTIP_ID = 'sensors-temperature-tooltip';

  const d115 = installationPoints.get('Pump 1');
  const d116 = installationPoints.get('Pump 2');

  return (
    <div className={style.row}>
      <div className={style.cell}>
        <div className={style.bathTempsContainer}>
          <div className={style.bathTempContainer}>
            <div className={style.bathText}>
              <span>MF5 Bath Temp</span> <span>MF5 Roof Temp</span>
            </div>
            <div className={style.bathIcon}>
              <span>MF5</span>
              <UnitIcon />
            </div>
          </div>
          <div className={cx(style.bathTempContainer, style.bathM1TempContainer)}>
            <div className={style.bathText}>
              <span>MF1 Bath Temp</span> <span>MF1 Roof Temp 2</span>
              <span>MF1 Roof Temp</span>
            </div>
            <div className={style.bathIcon}>
              <span>MF1</span>
              <UnitIcon />
            </div>
          </div>
        </div>
      </div>
      <div className={style.cell}>
        <StraightConnectorIcon
          className={cx(style.thinStraightConnectorIcon, style.firstStraightConnectorIcon)}
        />
        {/* placeholder container */}
        <div className={cx(style.sensorsEquipmentItemContainer, style.additionalTopPadding, style.hidden)}>
          <div className={style.equipmentIconContainer}>
            <EquipmentIcon />
          </div>
          <div className={style.temperature}>
            0.00 {userMetric}
            <IndicatorIcon className={style.indicatorIcon} />
          </div>
        </div>
        <div className={cx(style.sensorsEquipmentItemContainer, style.additionalTopPadding)}>
          <span className={style.name}>D-111</span>
          <div className={style.equipmentIconContainer}>
            <EquipmentIcon />
          </div>
          <div className={style.temperature}>
            0.00 {userMetric}
            <IndicatorIcon className={style.indicatorIcon} />
          </div>
        </div>
      </div>
      <div className={style.cell}>
        <StraightConnectorIcon className={style.thinStraightConnectorIcon} />
        <div className={cx(style.sensorsEquipmentItemContainer, style.additionalTopPadding)}>
          <span className={style.name}>D-112</span>
          <div className={style.equipmentIconContainer}>
            <EquipmentIcon />
          </div>
          <div className={style.temperature}>
            0.00 {userMetric}
            <IndicatorIcon className={style.indicatorIcon} />
          </div>
        </div>
        <div className={cx(style.sensorsEquipmentItemContainer, style.additionalTopPadding)}>
          <span className={style.name}>D-113</span>
          <div className={style.equipmentIconContainer}>
            <EquipmentIcon />
          </div>
          <div className={style.temperature}>
            0.00 {userMetric}
            <IndicatorIcon className={style.indicatorIcon} />
          </div>
        </div>
      </div>
      <div className={style.cell}>
        <StraightConnectorIcon className={style.thinStraightConnectorIcon} />
        <div className={cx(style.sensorsEquipmentItemContainer, style.additionalTopPadding)}>
          <span className={style.name}>D-114</span>
          <div className={style.equipmentIconContainer}>
            <EquipmentIcon />
          </div>
          <div className={style.temperature}>
            0.00 {userMetric}
            <IndicatorIcon className={style.indicatorIcon} />
          </div>
        </div>
        {d115 && (
          <div className={cx(style.sensorsEquipmentItemContainer, style.additionalTopPadding)}>
            <Link
              to={`/customer/${customerId}/sensors/${d115.equipmentId}/list`}
              className={cx(style.name, style.assetLink)}
              target="_blank"
              data-tooltip-id={SENSORS_TEMPERATURE_TOOLTIP_ID}
              data-tooltip-content={t('View Asset Details')}
            >
              D-115
              <DoubleArrowIcon className={style.doubleArrowIcon} />
            </Link>

            <Link
              to={`/customer/${customerId}/equipment-details/sensor/${d115.id}`}
              target="_blank"
              data-tooltip-id={SENSORS_TEMPERATURE_TOOLTIP_ID}
              data-tooltip-content={t('View Sensor Details')}
              className={style.sensorLink}
              data-tooltip-place="bottom"
            >
              <div className={style.equipmentIconContainer}>
                <EquipmentIcon className={style[d115.statusType]} />
              </div>
              <div className={cx(style.temperature, style[d115.statusType])}>
                {d115.temperature} {userMetric}
                <IndicatorIcon className={style.indicatorIcon} />
              </div>
            </Link>
          </div>
        )}
      </div>
      <div className={style.cell}>
        <StraightConnectorIcon
          className={cx(style.thinStraightConnectorIcon, style.lastStraightConnectorIcon)}
        />
        {d116 && (
          <div className={cx(style.sensorsEquipmentItemContainer, style.additionalTopPadding)}>
            <Link
              to={`/customer/${customerId}/sensors/${d116.equipmentId}/list`}
              className={cx(style.name, style.assetLink)}
              target="_blank"
              data-tooltip-id={SENSORS_TEMPERATURE_TOOLTIP_ID}
              data-tooltip-content={t('View Asset Details')}
            >
              D-116
              <DoubleArrowIcon className={style.doubleArrowIcon} />
            </Link>
            <Link
              to={`/customer/${customerId}/equipment-details/sensor/${d116.id}`}
              target="_blank"
              data-tooltip-id={SENSORS_TEMPERATURE_TOOLTIP_ID}
              data-tooltip-content={t('View Sensor Details')}
              className={style.sensorLink}
              data-tooltip-place="bottom"
            >
              <div className={style.equipmentIconContainer}>
                <D134EquipmentIcon className={style[d116.statusType]} />
              </div>
              <div className={cx(style.temperature, style[d116.statusType])}>
                {d116.temperature} {userMetric}
                <IndicatorIcon className={style.indicatorIcon} />
              </div>
            </Link>
          </div>
        )}

        {/* placeholder container */}
        <div className={cx(style.sensorsEquipmentItemContainer, style.additionalTopPadding, style.hidden)}>
          <div className={style.equipmentIconContainer}>
            <EquipmentIcon />
          </div>
          <div className={style.temperature}>
            0.00 {userMetric}
            <IndicatorIcon className={style.indicatorIcon} />
          </div>
        </div>
      </div>
      <div className={style.cell}>
        <AngleDowntimeIcon className={style.angleDowntimeIcon} />
        <div className={cx(style.sensorsEquipmentItemContainer, style.additionalTopPadding)}>
          <span className={style.name}>D-117</span>
          <div className={style.equipmentIconContainer}>
            <D134EquipmentIcon />
          </div>
          <div className={style.temperature}>
            0.00 {userMetric}
            <IndicatorIcon className={style.indicatorIcon} />
          </div>
        </div>
        <div className={cx(style.sensorsEquipmentItemContainer, style.additionalTopPadding)}>
          <span className={style.name}>D-118</span>
          <div className={style.equipmentIconContainer}>
            <D134EquipmentIcon />
          </div>
          <div className={style.temperature}>
            0.00 {userMetric}
            <IndicatorIcon className={style.indicatorIcon} />
          </div>
        </div>
      </div>
      <div className={style.cell}>
        <div className={cx(style.sensorsEquipmentItemContainer, style.additionalTopPadding)}>
          <span className={style.name}>D-119</span>
          <div className={style.equipmentIconContainer}>
            <D134EquipmentIcon />
          </div>
          <div className={style.temperature}>
            0.00 {userMetric}
            <IndicatorIcon className={style.indicatorIcon} />
          </div>
        </div>
        <div className={cx(style.sensorsEquipmentItemContainer, style.additionalTopPadding)}>
          <span className={style.name}>D-110</span>
          <div className={style.equipmentIconContainer}>
            <D134EquipmentIcon />
          </div>
          <div className={style.temperature}>
            0.00 {userMetric}
            <IndicatorIcon className={style.indicatorIcon} />
          </div>
        </div>
      </div>
      <div className={style.cell}>
        <AngelEndIcon className={style.angelEndIcon} />
        <div className={cx(style.bathTempContainer, style.rowReverse, style.bathM8TempContainer)}>
          <div className={style.bathText}>
            <span>MF8 Bath Temp</span> <span>MF8 Bath Temp 2</span> <span>MF8 Roof Temp</span>
          </div>
          <div className={style.bathIcon}>
            <span>MF8</span>
            <UnitIcon />
          </div>
        </div>
      </div>
      <Tooltip id={SENSORS_TEMPERATURE_TOOLTIP_ID} />
    </div>
  );
};

export default ThirdRow;
